import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { SearchModalComponent } from "@scaffold/editor/controls/search-modal/search-modal.component";
import { ItemsService } from "@scaffold/services/items.service";
import { ActivatedRoute } from "@angular/router";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { CourseService } from "../../../../services/course.service";
import cloneDeep from 'lodash/cloneDeep';
import { NbDialogService, NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TranslationService } from "@services/translation.service";
@Component({
  selector: "scaffold-data-search",
  templateUrl: "./scaffold-data-search.component.html",
  styleUrls: [
    "../../rendered.component.scss",
    "./scaffold-data-search.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScaffoldDataSearchComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();
  dialogRef: NbDialogRef<SearchModalComponent>;
  listUrl;
  originalItems;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    public dialog: NbDialogService,
    private itemsService: ItemsService,
    private route: ActivatedRoute,
    private courseService: CourseService,
    private translationService:TranslationService

  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });
    this.itemsService
      .registerReset()
      .pipe(takeUntil(this.destroy$))
      .subscribe((r) => {
        if (r == "reset") this.item.value = cloneDeep(this.originalItems);
        else if ((r = "saved")) this.originalItems = cloneDeep(this.item.value);
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  openSearch(selectedItem, allow_multiple?): void {
    let translatedLabel
    if(this.item?.translation_key){
      translatedLabel = this.translationService.getTranslatedContent(this.item.translation_key) 
      translatedLabel=!this.item.text_transform?translatedLabel:this.translationService.transform(translatedLabel,this.item.translation_key)
    }
    let settings: any = {
      context: {
        data: {
          selectedItem: selectedItem,
          currentValue: this.item.value,
          type: this.item.type,
          search_type: this.item.toload_type,
          search_mode: this.item.search_mode || "list",
          context: this.renderedService.getContext(this.item),
          route: this.route,
          allow_multiple: allow_multiple,
          window_title:
          translatedLabel||this.item.search_title ||
            ("Select Items to Link" + selectedItem.title
              ? " to " + selectedItem.title
              : ""),
          horizontal_list: this.item.horizontal_list,
          hide_search: this.item.hide_search,
          filter: this.item.filter_search,
          params: { param: this.item.param, req_value: this.item.req_value },
          prevent_create: this.item.prevent_create,
        },
      },
    };
    this.dialogRef = this.dialog.open(SearchModalComponent, settings);

    this.dialogRef.onClose.subscribe((result) => {
      console.log(result);
      if (result && result.length > 0) {
        console.log("SENDING DATA SEARCH");
        this.itemsService.updateValue(this.item.name, result, this.info);
      }
    });
  }
  getDataComponenet() {
    console.log(this.item);
    if (this.item.content) {
      this.item.view = this.item.content;
    } else {
      if (this.item.toload_id || this.value) {
        this.listUrl =
          this.item.toload_type +
          "/" +
          (this.item.value || this.item.toload_id) +
          "?mode=" +
          (this.item.toload_mode || "read");
        console.log(this.listUrl);
        this.courseService.get(this.listUrl).subscribe((co) => {
          this.item.view = co; //this.triggerUpdate("data view load");
          this.cdr.detectChanges();
        });
      }
    }
  }

  update() {
    this.getDataComponenet();
  }
}
